import type React from 'react'

export function EmptyHint({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        padding: '10px 12px',
        borderRadius: '8px',
        border: '1px dashed var(--border)',
        background: 'transparent',
        fontSize: 12,
        color: 'var(--muted-foreground)',
      }}
    >
      {children}
    </div>
  )
}
